var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89999 5.33447C3.93437 5.33447 4.77499 6.1751 4.77499 7.20947V14.1251C4.77499 15.1595 3.93437 16.0001 2.89999 16.0001C1.86562 16.0001 1.02499 15.1595 1.02499 14.1251V7.20947C1.02499 6.17197 1.86249 5.33447 2.89999 5.33447Z",
    fill: "#E09200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.03437 0 9.875 0.840625 9.875 1.875V14.125C9.875 15.1594 9.03437 16 8 16C6.96563 16 6.125 15.1594 6.125 14.125V1.875C6.125 0.840625 6.96563 0 8 0Z",
    fill: "#E09200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 10.6655C14.1344 10.6655 14.975 11.5062 14.975 12.5405V14.1249C14.975 15.1593 14.1344 15.9999 13.1 15.9999C12.0656 15.9999 11.225 15.1593 11.225 14.1249V12.5405C11.225 11.5062 12.0656 10.6655 13.1 10.6655Z",
    fill: "#E09200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBars);
export default __webpack_public_path__ + "static/media/yellowBars.a9c30512dcad89c9d69deac56838b8d7.svg";
export { ForwardRef as ReactComponent };